import { IconButton, Stack } from "@mui/material";
import { Close } from "@mui/icons-material";
import { FieldValues } from "react-hook-form";
import { FieldsListItemProps } from "./types";

interface FieldsItemProps<TFieldValues extends FieldValues = FieldValues> extends FieldsListItemProps<TFieldValues> {
  index: number;
}

const FieldsItem = <TFieldValues extends FieldValues = FieldValues>({
  renderFieldControlsComponent,
  index,
  disabled,
  fields,
  update,
  remove,
  dragHandleProps,
  handleIconNode,
}: FieldsItemProps<TFieldValues>) => {
  return (
    <Stack direction='row'>
      <div {...dragHandleProps}>{handleIconNode}</div>
      {renderFieldControlsComponent(index, update)}
      {fields?.length > 1 && (
        <IconButton
          onClick={() => remove(index)}
          disabled={disabled}>
          <Close sx={{ color: "base.200" }} />
        </IconButton>
      )}
    </Stack>
  );
};

export default FieldsItem;
